<template>
  <div class="content">
    <p class="title">招商概括</p>
    <el-form
      label-position="right"
      label-width="120px"
      :model="formData"
      :rules="rules"
      ref="refForm"
    >
      <el-form-item label="引进项目数量" prop="introduced_projects">
        <!-- <el-input type="number" min="0" class="numInput" v-model="formData.introduced_projects"></el-input> -->
        <el-input
          class="numInput"
          v-model.number="formData.introduced_projects"
          οninput="value=value.replace(/[^0-9]/g,'')"
        ></el-input>
      </el-form-item>
      <el-form-item label="招商完成率" prop="completion_rate">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.completion_rate"
        ></el-input>
      </el-form-item>
      <el-form-item label="招商入驻率" prop="settlement_rate">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.settlement_rate"
        ></el-input>
      </el-form-item>
      <p class="title">招商转化情况</p>
      <el-form-item label="已转化" prop="converted">
        <el-input
          class="numInput"
          @blur="convertedIup"
          type="number"
          min="0"
          max="100"
          v-model="formData.converted"
        >
          <template slot="append">%</template></el-input
        >
      </el-form-item>
      <el-form-item label="待转化" prop="to_be_converted">
        <el-input
          class="numInput"
          @blur="beConvertedIup"
          type="number"
          min="0"
          max="100"
          v-model="formData.to_be_converted"
        >
          <template slot="append">%</template></el-input
        >
      </el-form-item>
    </el-form>
    <!-- 招商引进月度工作 -->
    <p class="title">招商引进月度工作</p>
    <div class="formBox">
      <el-form
        v-for="(monthlyItem, monthlyIndex) in formData.monthly_investment"
        :ref="`monthlyForm${monthlyIndex}`"
        :key="'monthly' + monthlyIndex"
        :model="monthlyItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item label-width="120px" label="时间：" prop="time">
          <el-input
            disabled
            v-model="monthlyItem.year_month"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          >
            <template slot="append">月</template></el-input
          >
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="园区入驻数量"
          prop="park_settlements"
        >
          <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="monthlyItem.park_settlements"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input> -->
          <el-input
            class="numInput"
            placeholder="请输入内容"
            style="width: 207px; float: left"
            v-model.number="monthlyItem.park_settlements"
            οninput="value=value.replace(/[^0-9]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="园区空置面积"
          prop="park_vacant_area"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="monthlyItem.park_vacant_area"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 园区税收统计 -->
    <p class="title">
      园区税收统计
      <el-button style="margin-left: 20px" type="text" @click="addParkTax"
        >添加园区税收统计</el-button
      >
    </p>
    <div class="formBox">
      <el-form
        v-for="(parkTaxItem, parkTaxIndex) in formData.park_tax_statistics"
        :ref="`parkTaxForm${parkTaxIndex}`"
        :key="'parkTax' + parkTaxIndex"
        :model="parkTaxItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item
          label-width="120px"
          label="年份："
          prop="year"
          class="err_position"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="parkTaxItem.year"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="数量"
          prop="nums"
          class="err_position"
        >
          <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="parkTaxItem.nums"
            style="width: 207px; float: left"
            placeholder="请输入数量"
          ></el-input> -->
          <el-input
            class="numInput"
            style="width: 207px; float: left"
            v-model.number="parkTaxItem.nums"
            οninput="value=value.replace(/[^0-9]/g,'')"
          ></el-input>
          <i
            v-if="parkTaxIndex != 0"
            @click="delParkTax(parkTaxIndex)"
            style="margin-left: 15px; font-size: 20px"
            class="el-icon-delete"
          ></i>
        </el-form-item>
      </el-form>
    </div>
    <!-- 园区营收统计 -->
    <p class="title">
      园区营收统计
      <el-button style="margin-left: 20px" type="text" @click="addParkRevenue"
        >添加园区营收统计</el-button
      >
    </p>
    <div class="formBox">
      <el-form
        v-for="(
          parkRevenueItem, parkRevenueIndex
        ) in formData.park_revenue_statistics"
        :ref="`parkRevenueForm${parkRevenueIndex}`"
        :key="'parkRevenue' + parkRevenueIndex"
        :model="parkRevenueItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item label-width="120px" label="类型名称：" prop="type">
          <el-input
            v-model="parkRevenueItem.type"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="数量" prop="proportion">
          <!-- <el-input
          type="number" min="0" class="numInput"
            v-model="parkRevenueItem.proportion"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input> -->
          <el-input
            class="numInput"
            style="width: 207px; float: left"
            v-model.number="parkRevenueItem.proportion"
            οninput="value=value.replace(/[^0-9]/g,'')"
          ></el-input>
          <i
            v-if="parkRevenueIndex != 0"
            @click="delParkRevenue(parkRevenueIndex)"
            style="margin-left: 15px; font-size: 20px"
            class="el-icon-delete"
          ></i>
        </el-form-item>
      </el-form>
    </div>
    <el-form>
      <el-form-item>
        <el-button type="primary" @click="infoSubmit()">保存</el-button>
        <el-button @click="getInfo()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { yzJYConfigEdit, yzJYConfigDetail } from "@/api/yunzhou";
import { delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      loading: false, //是显示加载
      formData: {
        completion_rate: "",
        introduced_projects: "",
        settlement_rate: "",
        converted: "",
        to_be_converted: "",
        park_revenue_statistics: [
          {
            type: "55",
            proportion: "2",
          },
        ],
        park_tax_statistics: [
          {
            year: "24",
            nums: "45",
          },
        ],
        monthly_investment: [
          {
            year_month: "1",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "2",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "3",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "4",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "5",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "6",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "7",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "8",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "9",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "10",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "11",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "12",
            park_settlements: "",
            park_vacant_area: "",
          },
        ],
      },
      rules: {
        year_month: [
          { required: true, message: "请输入月份", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        park_settlements: [
          {
            required: true,
            message: "请输入园区入驻数量",
            trigger: "blur",
          },
        ],
        park_vacant_area: [
          {
            required: true,
            message: "请输入园区空置面积",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur",
          },
        ],
        proportion: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        introduced_projects: [
          { required: true, message: "请输入引进项目数量", trigger: "blur" },
        ],
        completion_rate: [
          { required: true, message: "请输入招商完成率", trigger: "blur" },
        ],
        settlement_rate: [
          { required: true, message: "请输招商入驻率", trigger: "blur" },
        ],
        converted: [
          { required: true, message: "请输入已转化", trigger: "blur" },
        ],
        to_be_converted: [
          { required: true, message: "请输入待转化", trigger: "blur" },
        ],
        year: [{ required: true, message: "请输入年份", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    convertedIup(e) {
      this.formData.to_be_converted = 100 - e.target.value;
    },
    beConvertedIup(e) {
      this.formData.converted = 100 - e.target.value;
    },
    // 获取基础信息
    getInfo() {
      yzJYConfigDetail().then((res) => {
        if (res.data.promotion_overview) {
          this.formData.introduced_projects = JSON.parse(
            res.data.promotion_overview
          ).introduced_projects;
          this.formData.completion_rate = JSON.parse(
            res.data.promotion_overview
          ).completion_rate;
          this.formData.settlement_rate = JSON.parse(
            res.data.promotion_overview
          ).settlement_rate;
        }
        if (res.data.investment_conversion_situation) {
          this.formData.converted = JSON.parse(
            res.data.investment_conversion_situation
          ).converted;
          this.formData.to_be_converted = JSON.parse(
            res.data.investment_conversion_situation
          ).to_be_converted;
        }
        if (res.data.monthly_investment) {
          this.formData.monthly_investment = JSON.parse(
            res.data.monthly_investment
          );
        }
        if (res.data.park_tax_statistics) {
          this.formData.park_tax_statistics = JSON.parse(
            res.data.park_tax_statistics
          );
        }
        if (res.data.park_revenue_statistics) {
          this.formData.park_revenue_statistics = JSON.parse(
            res.data.park_revenue_statistics
          );
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.activityFormVisible = false;
    },
    infoSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用

        // 招商引进月度工作
        ...this.formData.monthly_investment.map((item, index) =>
          this.validateForm(`monthlyForm${index}`)
        ),
        // 园区税收统计
        ...this.formData.park_tax_statistics.map((item, index) =>
          this.validateForm(`parkTaxForm${index}`)
        ),
        // 园区营收统计
        ...this.formData.park_revenue_statistics.map((item, index) =>
          this.validateForm(`parkRevenueForm${index}`)
        ),
        this.$nextTick(() => {
          that.elFormErrorScrollIntoView();
        }),
      ]).then((res) => {
        let overview = {
          introduced_projects: this.formData.introduced_projects,
          completion_rate: this.formData.completion_rate,
          settlement_rate: this.formData.settlement_rate,
        };
        let situation = {
          converted: this.formData.converted,
          to_be_converted: this.formData.to_be_converted,
        };
        let data = {
          promotion_overview: JSON.stringify(overview),
          investment_conversion_situation: JSON.stringify(situation),
          monthly_investment: JSON.stringify(this.formData.monthly_investment),
          park_tax_statistics: JSON.stringify(
            this.formData.park_tax_statistics
          ),
          park_revenue_statistics: JSON.stringify(
            this.formData.park_revenue_statistics
          ),
        };
        yzJYConfigEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },
    // 园区税收统计
    addParkTax() {
      this.formData.park_tax_statistics.push({
        year: "",
        nums: "",
      });
    },
    // 删除园区税收统计
    delParkTax(index) {
      this.formData.park_tax_statistics.splice(index, 1);
    },
    // 添加园区营收统计
    addParkRevenue() {
      this.formData.park_revenue_statistics.push({
        type: "",
        proportion: "",
      });
    },
    // 删除园区营收统计
    delParkRevenue(index) {
      this.formData.park_revenue_statistics.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}

.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
